module.exports = __webpack_public_path__ + "img/category_33.efb88e39.png";